import { i18n } from "@/config/i18n";

export default {
  name: 'TreeTvsiComponent',
  data() {
    return {
      importantNotes: [
        { id: 1, color: '#c8a246', text: i18n.global.t("about.fees50backcome") },
        { id: 2, color: '#2f8c56', text: i18n.global.t("about.income10sys")    },
        { id: 3, color: '#b8922a', text: i18n.global.t("about.notIncludeTax")  },
        { id: 4, color: '#7a7268', text: i18n.global.t("about.applyRule")      },
      ],
    };
  },
};
